import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import StyledTab from '../../common/tabs/SimpleTab';
import SimpleTabs from '../../common/tabs/SimpleTabs';
import { a11yProps } from '../../../helpers/utils';
import TabPanel from '../../common/tabs/SimpleTabPanel';
import Loader from '../../common/Loader';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import SwipeableViews from 'react-swipeable-views';
import Eof from '../../common/Eof';
import useDesktopDisplay from '../../../hooks/useDesktopDisplay';
import Checkbox from '@material-ui/core/Checkbox';
import { generatePath, useHistory } from 'react-router-dom';
import { routes } from '../../../assets/routes';
import {
  Feedback,
  Reco,
  Favorite,
  Chat
} from '../../../assets/icons/iconComponents';
import { parseDate } from '../../../helpers/date';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import {
  getNotificationsListRequest,
  getTodosListRequest,
  markAllAsSeenRequestRequest
} from './api';
import { Badge } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getNotificationsCountRequest } from '../../../helpers/api';
import Button from '@mui/material/Button';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import { useTranslation } from '../../../i18n/LanguageProvider';

const useStyles = makeStyles(() => ({
  badge: {
    fontSize: 10
  }
}));

const NotificationsList = () => {
  const { t, isRtl } = useTranslation();
  const dispatch = useDispatch();
  const isDesktop = useDesktopDisplay();
  const history = useHistory();
  const classes = useStyles();

  const [tabIndex, setTabIndex] = useState(0);
  const [done, setDone] = useState(false);
  const [seen, setSeen] = useState([]);
  const [todoState, setTodoState] = useState({});
  const [undoneCount, setUndoneCount] = useState(0);

  const entityTypes = {
    mood_message: routes.MOOD_TRACKER,
    kudos: routes.KUDOS,
    reply_kudos_comment: routes.KUDOS,
    kudos_comment: routes.KUDOS,
    feedback_comment: routes.FEEDBACK,
    feedback_request: routes.FEEDBACK,
    like: routes.KUDOS,
    announcement: routes.ANNOUNCEMENT,
    survey: routes.SURVEY
  };
  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabIndex(index);
  };

  const {
    isLoading: todosIsLoading,
    data: todosData,
    hasNextPage: todosHasNextPage,
    fetchNextPage: todosFetchNextPage,
    isFetchingNextPage: todosIsFetchingNextPage
  } = useInfiniteQuery(
    ['todosList', done],
    ({ pageParam = 1 }) => getTodosListRequest(pageParam, done),
    {
      select: React.useCallback(
        (data) => data?.pages.flatMap((todo) => todo.data),
        []
      ),
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = allPages.length + 1;
        return lastPage.data.length !== 0 ? nextPage : undefined;
      },
      onSuccess(response) {
        //MARK
        let temp = {};
        response.forEach((task) => (temp[task.id] = task.done));
        setTodoState({ ...temp, ...todoState });
      },
      onError(err) {
        toast.error(err.response?.data?.detail);
      }
    }
  );
  console.log(todosData);
  const { refetch } = useQuery(
    ['notificationsCount'],
    getNotificationsCountRequest,
    {
      onSuccess({ data: { todo_count } }) {
        setUndoneCount(todo_count);
      }
    }
  );

  const {
    isLoading: notificationsIsLoading,
    data: notificationsData,
    hasNextPage: notificationsHasNextPage,
    fetchNextPage: notificationsFetchNextPage,
    isFetchingNextPage: notificationsIsFetchingNextPage
  } = useInfiniteQuery(
    ['notificationsList'],
    ({ pageParam = 1 }) => getNotificationsListRequest(pageParam),
    {
      select: React.useCallback(
        (data) => data?.pages.flatMap((todo) => todo.data),
        []
      ),
      onSuccess(response) {
        refetch();
        response.map((notification) => {
          setSeen((seen) => [...seen, notification.seen]);
        });
      },
      getNextPageParam: (lastPage, allPages) => {
        const nextPage = allPages.length + 1;
        return lastPage.data.length !== 0 ? nextPage : undefined;
      },
      onError(err) {
        toast.error(err.response?.data?.detail);
      }
    }
  );

  const markAllAsSeenRequestMutation = useMutation(
    markAllAsSeenRequestRequest,
    {
      onSuccess() {
        toast.success(t('notifications.allSeenToast'));
        setSeen([]);
        seen.map(() => {
          setSeen((seen) => [...seen, true]);
        });
      },
      onError(err) {
        toast.error(err.response?.data?.detail);
      }
    }
  );

  useEffect(() => {
    setHeader(t('notifications.title'));
    setHeaderConfigs({ credits: false, exit: false, back: true, logo: false });
  }, []);

  const changeAddress = (type, id) => {
    history.push(generatePath(entityTypes[type], { id }));
  };

  return (
    <div className={styles.page}>
      <Helmet>
        <title>{t('notifications.title')}</title>
      </Helmet>
      {isDesktop && (
        <div className={styles.pageHeader}>
          <span>{t('notifications.title')}</span>
        </div>
      )}
      <div className={styles.section}>
        <div className={styles.sectionTop}>
          <SimpleTabs value={tabIndex} handleChange={handleChange}>
            <StyledTab
              label={t('notifications.tabNotifications')}
              {...a11yProps(0)}
            />
            <StyledTab
              label={
                <div
                  style={
                    undoneCount
                      ? { [isRtl ? 'paddingLeft' : 'paddingRight']: '15px' }
                      : {}
                  }
                >
                  <Badge
                    max={99}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: isRtl ? 'left' : 'right'
                    }}
                    classes={{ badge: classes.badge }}
                    badgeContent={undoneCount}
                    color="secondary"
                  >
                    {/* keeps the badge, centered on the corner, off the label */}
                    <span
                      style={undoneCount ? { paddingInlineEnd: '10px' } : {}}
                    >
                      {t('notifications.tabTodos')}
                    </span>
                  </Badge>
                </div>
              }
              {...a11yProps(1)}
            />
          </SimpleTabs>
          {tabIndex === 1 ? (
            <div className={styles.button}>
              <Button
                sx={{ width: 'max-content' }}
                variant="outlined"
                size="small"
                onClick={() => {
                  setDone(!done);
                }}
              >
                {done ? (
                  <span>{t('notifications.undone')}</span>
                ) : (
                  <span>{t('notifications.done')}</span>
                )}{' '}
              </Button>
            </div>
          ) : (
            <div className={styles.button}>
              <Button
                sx={{ width: 'max-content' }}
                variant="outlined"
                size="small"
                onClick={() => markAllAsSeenRequestMutation.mutate({})}
              >
                {t('notifications.markAllSeen')}{' '}
              </Button>
            </div>
          )}
        </div>

        <div className={classNames(styles.sectionBody, styles.noMargin)}>
          <SwipeableViews
            axis={isRtl ? 'x-reverse' : 'x'}
            index={tabIndex}
            onChangeIndex={handleChangeIndex}
            className={styles.swipeArea}
          >
            <TabPanel index={0} value={tabIndex}>
              {notificationsIsLoading ? (
                <Loader size={40} />
              ) : notificationsData.length ? (
                <div className={styles.notification}>
                  {notificationsData.map((notification, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        changeAddress(
                          notification.entity_type,
                          notification.entity_id
                        );
                      }}
                      className={
                        seen[i]
                          ? styles.listRow
                          : classNames(
                              styles.listRow,
                              seen.length === notificationsData?.length &&
                                styles.seen
                            )
                      }
                    >
                      {notification.entity_type === 'kudos' ||
                      notification.entity_type === 'reply_kudos_comment' ||
                      notification.entity_type === 'kudos_comment' ? (
                        <Reco />
                      ) : notification.entity_type === 'feedback_comment' ? (
                        <Feedback />
                      ) : notification.entity_type === 'like' ? (
                        <Favorite />
                      ) : notification.entity_type === 'announcement' ? (
                        <DescriptionRoundedIcon />
                      ) : notification.entity_type === 'mood_message' ? (
                        <Chat />
                      ) : null}
                      <div>
                        {notification.notification_repr}
                        <div className={styles.time}>
                          {' '}
                          {parseDate(notification.created_at)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className={classNames(styles.emptyCard, styles.feedback)}>
                  {t('notifications.empty')}
                </div>
              )}
              {!notificationsIsLoading &&
                (notificationsIsFetchingNextPage ? (
                  <Loader size={40} />
                ) : notificationsHasNextPage ? (
                  <Button
                    variant="outlined"
                    onClick={notificationsFetchNextPage}
                    fullWidth
                  >
                    {t('common.more')}
                  </Button>
                ) : (
                  <Eof />
                ))}
            </TabPanel>
            <TabPanel index={1} value={tabIndex}>
              {todosIsLoading ? (
                <Loader size={40} />
              ) : todosData.length ? (
                todosData.map((task, index) => (
                  <div key={index} className={styles.todo}>
                    <Checkbox checked={done ? true : false} />
                    <div
                      onClick={() => {
                        changeAddress(task.entity_type, task.entity_id);
                      }}
                    >
                      {task.todo_repr}
                    </div>
                  </div>
                ))
              ) : (
                <div className={classNames(styles.emptyCard, styles.notif)}>
                  {t('notifications.emptyTodos')}
                </div>
              )}
              {!todosIsLoading &&
                (todosIsFetchingNextPage ? (
                  <Loader size={40} />
                ) : todosHasNextPage ? (
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={todosFetchNextPage}
                  >
                    {t('common.more')}
                  </Button>
                ) : (
                  <Eof />
                ))}
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </div>
  );
};

export default NotificationsList;
